import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * React Query hook for fetching user's activity history
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useActivityQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["activity", userId],
    queryFn: async () => {
      const res = await api.get("/users/me/activity");
      return res.data.activities || [];
    },
    enabled: enabled && !!userId,
  });
};
